import { render } from "./ProgressIcon.vue?vue&type=template&id=509364b3&ts=true"
import script from "./ProgressIcon.vue?vue&type=script&lang=ts"
export * from "./ProgressIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__